<template>
  <div style="width: 100%">
    <div class="logo">
      <span class="name">果园工作台</span>
    </div>
    <a-menu
      :default-selected-keys="['1']"
      :open-keys="openKeys"
      :selected-keys="[$route.name]"
      mode="inline"
      theme="dark"
      :inline-collapsed="collapsed"
      @click="handleMenuClick"
      @openChange="handleOpenChange"
    >
      <template v-for="item in menu_list">
        <a-sub-menu :key="item.view" v-if="item.children.length">
          <span slot="title">
            <a-icon :type="item.icon" />
            <span>{{ $t(`menu.${item.view}`) }}</span>
          </span>
          <template v-for="elem in item.children">
            <a-menu-item :key="elem.view">
              {{ $t(`menu.${elem.view}`) }}
            </a-menu-item>
          </template>
        </a-sub-menu>
        <a-menu-item :key="item.view" v-else>
          <a-icon :type="item.icon" />
          <span>{{ $t(`menu.${item.view}`) }}</span>
        </a-menu-item>
      </template>

      <a-menu-item key="message" class="bottom">
        <a-icon type="message" />
        <a-badge dot :count="count">
          <span>{{ $t(`menu.message`) }}</span>
        </a-badge>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
import { Menu } from "ant-design-vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "Sidebar",
  props: ["collapsed", "count"],
  components: {
    "a-menu": Menu,
    "a-sub-menu": Menu.SubMenu,
    "a-menu-item": Menu.Item,
  },
  computed: {
    ...mapState(["menu_list", "panes"]),
  },
  data() {
    return {
      openKeys: [],
    };
  },
  mounted() {
    this.handleMenuOpenedKeys();
  },
  methods: {
    ...mapMutations(["setState"]),
    handleMenuOpenedKeys() {
      this.openKeys = [
        this.$route.path.replace(/[^/]+(?!.*\/)/, "").replace(/\//g, ""),
      ];
    },
    handleOpenChange(openKeys) {
      let keys;
      if (openKeys.length > 1) {
        if (openKeys.length > 2) {
          keys = [openKeys[openKeys.length - 1]];
        } else if (openKeys[1].indexOf(openKeys[0]) > -1) {
          keys = [openKeys[0], openKeys[1]];
        } else {
          keys = [openKeys[openKeys.length - 1]];
        }
        this.openKeys = keys;
      } else {
        this.openKeys = openKeys;
      }
    },
    handleMenuClick(route) {
      if (route.key === this.$route.name) return;
      if (route.key === "message") {
        this.$emit("update:count", 0);
        this.$emit("showMessage");
        return;
      }
      if (!this.panes.includes(route.key)) {
        this.panes.push(route.key);
        this.setState({ panes: this.panes });
      }
      this.$router.push({ name: route.key });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/css/mixin.scss";
.logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  .name {
    color: $white;
  }
}
.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: 0;
  background-color: #4c4c4c;
  &:hover {
    background-color: #4c4c4c;
  }
}
</style>

<style>
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  font-size: 13px;
}
</style>
